const URIS = {
  stores: {
    development: process.env.STORES_URI || 'http://localhost:3000/s',
    staging:
      process.env.STORES_URI || 'https://www-master.staging.customink.com/s',
    production: 'https://www.customink.com/s'
  },
  storefront: {
    development: process.env.STOREFRONT_URI || 'http://localhost:8080/go',
    staging:
      process.env.STOREFRONT_URI ||
      'https://www-master.staging.customink.com/go',
    production: 'https://www.customink.com/go'
  },
  user: {
    development: process.env.STORES_URI || 'http://localhost:3000/s',
    staging:
      process.env.STORES_URI || 'https://www-master.staging.customink.com/s',
    production: 'https://www.customink.com/s'
  },
  designs: {
    development:
      process.env.DESIGN_SERVICE_URI ||
      'https://www-master.staging.customink.com/api/designs',
    staging:
      process.env.DESIGN_SERVICE_URI ||
      'https://www-master.staging.customink.com/api/designs',
    production: 'https://www.customink.com/api/designs'
  },
  products: {
    development:
      process.env.MMS_URI || 'https://mms.staging.customink.com/mms/api/out',
    staging:
      process.env.MMS_URI ||
      'https://www-master.staging.customink.com/mms/api/out',
    production: 'https://www.customink.com/mms/api/out'
  },
  mmsImages: {
    development:
      process.env.MMS_IMAGES_URI ||
      'https://mms-images.staging.customink.com/mms/images',
    staging:
      process.env.MMS_IMAGES_URI ||
      'https://mms-images.staging.customink.com/mms/images',
    production: 'https://mms-images.out.customink.com/mms/images'
  },
  homePage: {
    development:
      process.env.HOMEPAGE_URI || 'https://www-master.staging.customink.com',
    staging:
      process.env.HOMEPAGE_URI || 'https://www-master.staging.customink.com',
    production: 'https://www.customink.com'
  }
} as UrisInterface;

type UrisInterface = {
  [key: string]: EnvironmentUris;
};

type EnvironmentKey = 'development' | 'staging' | 'production';

type EnvironmentUris = {
  [key in EnvironmentKey]: string;
};

let env: EnvironmentKey;
if (__DEVELOPMENT__) {
  env = 'development';
} else if (__STAGING__) {
  env = 'staging';
} else {
  env = 'production';
}

type Services = {
  [key: string]: string;
};

const serviceKeys = Object.keys(URIS);
const services = serviceKeys.reduce((acc, curr) => {
  return {...acc, [curr]: URIS[curr][env]};
}, {}) as Services;

export default services;
